import { qcpLayoutToggleAtom } from "../../store";
import { type Layout } from "../../components/CoverTogglesContainer/ExperimentGridView/LayoutToggle";
import { useExperiment } from "../experiments";
import { useHydrateAtoms } from "jotai/utils";

// Sets the initial state of the layout toggle atom
//
// There are two treatment variants for the experiment:
// - users in "treatment_grid" will see the grid layout by default
// - users in "treatment_list" will see the list layout by default
// If a layout is stored in Chopin's session storage, it will override the default layout
//
// Otherwise, this defaults to list, the control layout
export const useSetLayoutToggleAtom = (defaultLayout?: Layout) => {
  const variant = useExperiment("uk2505Gridvslistview") || "";
  const isTreatment = ["treatment_grid", "treatment_list"].includes(variant);

  const layout: Layout = isTreatment
    ? defaultLayout || (variant === "treatment_grid" ? "grid" : "list")
    : "list";

  useHydrateAtoms([[qcpLayoutToggleAtom, layout]]);
};
